// @flow
import {prepareRequestData} from './prepare-request-data';
import {isOk} from './utils/is-ok';
import {ApiMethods, CONTENT_TYPE_KEY} from './constants';

import type {UploadFile} from './typedef';

export const uploadFile: UploadFile = (callInfo, apiRoot, store) => {
    // eslint-disable-next-line no-unused-vars
    const {onProgress, signal, ...rest} = callInfo;

    const pack = prepareRequestData(rest, apiRoot);
    const headerKeys = Object.keys(pack.headers).filter(header => header !== CONTENT_TYPE_KEY);

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        const abortListener = () => {
            xhr.abort();
        }

        const cleanup = () => {
            if (signal) {
                signal.removeEventListener('abort', abortListener);
            }
        }

        xhr.upload.onprogress = event => {
            if (callInfo.onProgress) {
                callInfo.onProgress(event);
            }
        };

        xhr.onabort = () => {
            cleanup();
            reject({
                error: 'Upload aborted',
                response: {ok: false, status: 0}
            })
        }

        xhr.onreadystatechange = () => {
            if (xhr.readyState !== 4) {
                return;
            }
            cleanup();
            let responseData;

            try {
                responseData = JSON.parse(xhr.responseText);
            } catch (e) {
                responseData = xhr.responseText;
            }

            const ok = isOk(xhr.status);
            resolve({
                responseData,
                response: {ok, status: xhr.status}
            });
        };

        xhr.open(callInfo.method || ApiMethods.POST, pack.url);

        headerKeys.forEach(key => {
            xhr.setRequestHeader(key, pack.headers[key]);
        });

        if (signal) {
            if (signal.aborted) {
                xhr.abort();
                return;
            }

            signal.addEventListener('abort', abortListener);
        }

        xhr.send(pack.body);
    });
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
